import { apiFetch } from './client'

export const inventoryApi = {
  list: (token: string) =>
    apiFetch<any[]>('/inventorylist', token),

  setTrialOverride: (token: string, capacityId: string, tenantId: string, overrideDate: string | null) =>
    apiFetch<void>('/inventory/trial-override', token, {
      method: 'PUT',
      body: JSON.stringify({ capacityId, tenantId, overrideDate }),
    }),

  getPipelineComposition: (token: string, pipelineName: string) =>
    apiFetch<any>(`/pipeline/${encodeURIComponent(pipelineName)}/composition`, token),
}
